import React, { Ref } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import useTelemetry from '@monorepo/shared/src/hooks/use-telemetry';
import type { RouteSource } from '@monorepo/shared/src/graph/schema-generated-types-student';
import { AppRoutes, TelemetryEvents } from '@monorepo/shared/src/types';

export type ButtonProps = MuiButtonProps & {
  redirectRoute?: { title?: AppRoutes; path: string };
  startIcon?: IconDefinition;
  endIcon?: IconDefinition;
  from?: RouteSource;
  showTextLabel?: boolean;
  containerStyle?: React.CSSProperties;
};

const Button: React.FC<ButtonProps> = React.forwardRef(
  (
    { children, redirectRoute, startIcon, endIcon, onClick, from, ...rest },
    ref: Ref<HTMLButtonElement>
  ) => {
    const [, { fireEvent }] = useTelemetry(TelemetryEvents.ACCESS_LINK);
    const navigate = useNavigate();

    const handleButtonClick = (e: any) => {
      onClick?.(e);
      if (redirectRoute) {
        const { title: redirectTitle, path } = redirectRoute;
        redirectTitle && from && fireEvent({ link: redirectTitle, route: from });
        navigate(path);
        return;
      }
    };

    return (
      <MuiButton
        variant="contained"
        onClick={handleButtonClick}
        startIcon={startIcon && <FontAwesomeIcon icon={startIcon} />}
        endIcon={endIcon && <FontAwesomeIcon icon={endIcon} />}
        ref={ref}
        {...rest}
      >
        {children}
      </MuiButton>
    );
  }
);

export default Button;
